import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalResponse } from '../../../models/shared-component/modal-response-model';

@Component({
  selector: 'app-confirm-modal',
  templateUrl: './confirm-modal.component.html',
  styleUrls: ['./confirm-modal.component.scss']
})
export class ConfirmModalComponent implements OnInit {
  @Input() title: string;
  @Input() message: string;
  @Input() cancelButtonTitle: string;
  @Input() confirmButtonTitle: string;
  @Input() isShowAttachment: boolean = true;

  @Output() action = new EventEmitter<ModalResponse>();

  isChecked = false;

  constructor(public bsModalRef: NgbActiveModal) { }

  ngOnInit(): void {
  }

  confirm(): void {
    const response = new ModalResponse();
    response.isConfirm = true;
    this.action.emit(response);
    this.bsModalRef.close();
  }

  cancel(): void {
    const response = new ModalResponse();
    response.isConfirm = false;
    this.action.emit(response);
    this.bsModalRef.close();
  }

}
